import { ENV } from "../utils";

export class Suscriptor {
  baseApi = ENV.BASE_API;

  async getAll(accessToken) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.SUSCRIPTORES}`, {
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async subscribe({ nombre, email }) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.SUSCRIPTORES}`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ nombre, email }),
    });
    const data = await res.json();
    if (res.status !== 201) throw data;
    return data;
  }

  async toggle(accessToken, id) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.SUSCRIPTORES}/${id}/toggle`, {
      method: "PATCH",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }

  async remove(accessToken, id) {
    const res = await fetch(`${this.baseApi}/${ENV.API_ROUTES.SUSCRIPTORES}/${id}`, {
      method: "DELETE",
      headers: { Authorization: `Bearer ${accessToken}` },
    });
    const data = await res.json();
    if (res.status !== 200) throw data;
    return data;
  }
}
